import {RRule} from "rrule";

/**
 * Fix for rrule library bug where UNTIL dates with commas are generated when the year is between 0000 and 0009 inclusive
 *
 * Typing a 2 into the date input for 2025 the year will be initially 0002.
 *
 * @param rule
 */
export function fixRRuleUntil(rule: RRule): string {
  return rule?.toString().replace(/(UNTIL=)([^;]+)/, (_, prefix, untilValue) => {
    // Replace any comma in the UNTIL date with zero
    const fixedUntilValue = untilValue.replace(',', '0');
    return prefix + fixedUntilValue;
  });
}